/**
 * Get information from react router
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * IMPORTANT: make sure components are wrapped with withRouter
 */

import _get from "lodash/get";

/**
 * Return the current hash from the state (has to use ownProps because of withRouter)
 * @type {{}}
 */
export const getRouterStateHash = (ownProps) => {
    return _get(ownProps, "location.hash", "");
};

/**
 * Return the current hash from the state (has to use ownProps because of withRouter)
 * @type {{}}
 */
export const getRouterStateHashArticleGroupingId = (ownProps) => {
    const [hash, id] = getRouterStateHash(ownProps).match(/#article_(\d+)/) || [];
    return id;
};
